/**
 * Feature setting for showing all languages in the self-serve help center
 */
export const SELF_SERVE_SHOW_ALL_LANGUAGES_241003 =
  'SELF_SERVE_SHOW_ALL_LANGUAGES_241003';
